/**
 * returns the sum of the given arguments
 * @param  {...Number|String} operands
 * @returns {Number}
 */
export const getClosestIntegerSum = (...operands) => {
  return operands.reduce((acc, cur) => {
    // returns accumulator for values that cannot be coerced to a number
    if (
      !cur ||
      typeof cur === 'symbol' || // cannot be coerced
      typeof cur === 'object' // cannot be coerced in some cases
    ) {
      return acc;
    }

    // get floating point number
    const number = parseFloat(cur);

    // round to closest integer
    const closestInteger = Math.round(number);

    // return accumulator is integer is not safe
    if (!Number.isSafeInteger(closestInteger)) {
      return acc;
    }
    return acc + closestInteger;
  }, 0);
};
